"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORDER_ON_BEHALF_DIALOG_CHANGE_CONSULTANT_INPUT = exports.ORDER_FORM_ROOT = void 0;
const ORDER_FORM_ROOT = exports.ORDER_FORM_ROOT = 'order-form-root';
const ORDER_ON_BEHALF_DIALOG_CHANGE_CONSULTANT_INPUT = exports.ORDER_ON_BEHALF_DIALOG_CHANGE_CONSULTANT_INPUT = 'order-on-behalf-dialog-change-consultant-input';
